import type { PaginatedResponse, ReimbursmentRequest } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type Args = {
	page?: number;
	perPage?: number;
};

export function useGetReimbursementsRequest(args: Args = {}) {
	return useQuery({
		queryKey: ["reimbursements", args.page, args.perPage],
		queryFn: async () => {
			const res = await fetch(constructUrl(args), {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to fetch reimbursement requests");
			}

			return (await res.json()) as PaginatedResponse<ReimbursmentRequest>;
		},
	});
}

function constructUrl(args: Args): string {
	const url = new URL(`${SERVICE_API}/api/reimbursement-requests`);

	if (args.page) {
		url.searchParams.append("page", args.page.toString());
	}

	if (args.perPage) {
		url.searchParams.append("perPage", args.perPage.toString());
	}

	return url.toString();
}
